import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmarkCircle",
  "use": "checkmarkCircle-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 48 48\" id=\"checkmarkCircle\">\n  <path d=\"M24 4a20 20 0 1 0 20 20A20 20 0 0 0 24 4m-2 27.914-7.707-7.707 1.414-1.414L22 29.086l12.793-12.793 1.414 1.414Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol